import _ from 'lodash'
import React, { Component, PropTypes, Children } from 'react'
import CSSModules from 'react-css-modules'
import { connect } from 'react-redux'
import DocumentTitle from 'react-document-title'

import {
  eventGroupLoadPage,
  eventGroupLoadPerformances,
  eventGroupLoadPastPerformances,
  eventGroupSetPerformancesViewType,
} from 'actions/event-group'
import {
  draftEventGroupCancel,
  draftEventGroupEdit,
  draftEventGroupSave,
  draftEventGroupUpdateField } from 'actions/draft/eventgroup'
import {
  getEventGroupVenue,
  getPerformanceGroups,
  getPastPerformanceGroups,
  showCurrentPerformances,
  getEventGroupMarket,
  getEventGroupPerformancesViewIndex,
  getChangedDraftEventGroup,
  isEditable,
  isSaving,
} from 'selectors/event-group'
import { getEventGroup } from 'selectors/entities'
import { canLoadMore, isFetching } from 'selectors/paginate'
import { getCurrentPartner, getFeatureFlag } from 'selectors/settings'
import LoadingSpinner from 'components/loading-spinner'
import EventHeader from 'components/event-header'

import styles from './event-group-page.css'

export class EventGroupPage extends Component {

  componentDidMount() {
    this.props.eventGroupLoadPage(this.props.params.eventGroupId)
  }

  getPageOptions() {
    const { routes } = this.props
    const pathName = routes[routes.length - 1].path

    if (!pathName) {
      return {
        root: true,
        showBottomBar: true,
        subtitle: null,
      }
    }

    const pages = {
      details: {
        root: false,
        showBottomBar: false,
        subtitle: 'Event Details',
      },
      integrations: {
        root: false,
        showBottomBar: false,
        subtitle: 'Event Integrations',
      },
    }
    return pages[pathName]
  }

  render() {
    const {
      eventGroup,
      venue,
      market,
      performanceGroups,
      partner,
      showSummaryLink,
      showEditLink,
      children,
    } = this.props


    if (!eventGroup || !venue || !market || !performanceGroups || !partner) {
      return <LoadingSpinner />
    }

    const childrenProps = _.omit(this.props, ['children', 'styles'])
    const pageOptions = this.getPageOptions()

    return (
      <DocumentTitle title={`Ecommerce Portal - Time Out - ${eventGroup.name}`}>
        <div styleName="event-group-page">
          <EventHeader
            isRoot={pageOptions.root}
            addNewDatesUrl={eventGroup.addNewDatesUrl}
            currencyCode={market.currency.code}
            eventGroupId={eventGroup.id}
            partnerId={partner.id}
            showBottomBar={pageOptions.showBottomBar}
            showSummaryLink={showSummaryLink}
            showEditLink={showEditLink}
            soldTickets={eventGroup.soldTickets}
            subtitle={pageOptions.subtitle}
            title={eventGroup.name}
            totalPartnerShare={eventGroup.totalPartnerShare}
            whitelabelUrl={eventGroup.whitelabelUrl}
          />
          {Children.map(children, child => React.cloneElement(child, childrenProps))}
        </div>
      </DocumentTitle>
    )
  }
}

EventGroupPage.propTypes = {
  children: PropTypes.any,
  eventGroup: PropTypes.object,
  eventGroupLoadPage: PropTypes.func,
  params: PropTypes.object,
  venue: PropTypes.object,
  market: PropTypes.object,
  partner: PropTypes.object,
  performanceGroups: PropTypes.array,
  routes: PropTypes.array,
  showSummaryLink: PropTypes.bool,
  showEditLink: PropTypes.bool,
}

const mapStateToProps = (state, ownProps) => {
  const { eventGroupId } = ownProps.params
  return {
    canLoadMorePerformances: canLoadMore('eventGroupPerformances', eventGroupId)(state),
    canLoadMorePastPerformances: canLoadMore('eventGroupPastPerformances', eventGroupId)(state),
    editable: isEditable(state),
    eventGroup: getEventGroup(eventGroupId)(state),
    draftEventGroup: getChangedDraftEventGroup(state),
    isDataFetching: isFetching('eventGroupPerformances', eventGroupId)(state),
    isDataFetchingPast: isFetching('eventGroupPastPerformances', eventGroupId)(state),
    venue: getEventGroupVenue(eventGroupId)(state),
    market: getEventGroupMarket(eventGroupId)(state),
    partner: getCurrentPartner(state),
    pastPerformanceGroups: getPastPerformanceGroups(eventGroupId)(state),
    performanceGroups: getPerformanceGroups(eventGroupId)(state),
    showCurrentPerformances: showCurrentPerformances(state),
    selectedTabIndex: getEventGroupPerformancesViewIndex(state),
    saving: isSaving(state),
    showSummaryLink: getFeatureFlag('portal_event_group_summary')(state),
    showEditLink: getFeatureFlag('portal_enable_edit_event_group_grid_link')(state),
  }
}

const mapDispatchToProps = {
  eventGroupLoadPage,
  eventGroupLoadPerformances,
  eventGroupLoadPastPerformances,
  eventGroupSetPerformancesViewType,
  draftEventGroupCancel,
  draftEventGroupEdit,
  draftEventGroupSave,
  draftEventGroupUpdateField,
}

export default connect(mapStateToProps, mapDispatchToProps)(CSSModules(EventGroupPage, styles))



/** WEBPACK FOOTER **
 ** ./src/containers/event-group-page/event-group-page.js
 **/